import { NavLink, Outlet, useLocation } from "react-router-dom";
import clsx from "clsx";
import { AlertTriangle, List } from "lucide-react";

// URL-driven tabs: one <NavLink> per tab. The ":transactionId" and
// "legacy/:transactionId" detail routes share this layout but hide the tab
// bar so the detail view has full real estate.
const TABS = [
  {
    to: "/transactions/needs-attention",
    label: "Needs Attention",
    icon: <AlertTriangle size={16} />,
  },
  {
    to: "/transactions/all",
    label: "All",
    icon: <List size={16} />,
  },
];

const Transactions = () => {
  const { pathname } = useLocation();
  const isDetailView =
    /^\/transactions\/(legacy\/)?[^/]+$/.test(pathname) &&
    !TABS.some((t) => t.to === pathname);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold">Transactions</h2>
      </div>

      {!isDetailView && (
        <div className="flex gap-2 border-b border-gray-200">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                clsx(
                  "flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors",
                  isActive
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-gray-600 hover:text-gray-900",
                )
              }
            >
              {tab.icon}
              {tab.label}
            </NavLink>
          ))}
        </div>
      )}

      <Outlet />
    </div>
  );
};

export default Transactions;
